import * as type from './actionTypes';
import {
  ASSIGNED_TO_WRITERS_REPORT_ERROR,
  ASSIGNED_TO_WRITERS_REPORT_LOADING,
  ASSIGNED_TO_WRITERS_REPORT_SUCCESS,
} from './components/AssignedToWritersReport/reportStates';
import * as audioReportState from './components/AudioReport/audioReportStates';
import {
  BOOKS_MISSING_ANSWERS_REPORT_ERROR,
  BOOKS_MISSING_ANSWERS_REPORT_LOADING,
  BOOKS_MISSING_ANSWERS_REPORT_SUCCESS,
} from './components/BooksMissingAnswersReport/reportStates';
import {
  REFERRED_LEADS_REPORT_ERROR,
  REFERRED_LEADS_REPORT_LOADING,
  REFERRED_LEADS_REPORT_SUCCESS,
} from './components/ReferredLeadsReport/reportStates';
import {
  SELF_PROMOTION_REPORT_ERROR,
  SELF_PROMOTION_REPORT_LOADING,
  SELF_PROMOTION_REPORT_SUCCESS,
} from './components/SelfPromotionReport/reportStates';

export const getBibliographyReportForGivenRates = (
  rates,
  selectedRatingExams,
  multiple,
) => ({
  type: type.GET_BIBLIOGRAPHY_REPORT_FOR_RATES,
  rates,
  selectedRatingExams,
  multiple,
});

export const getBibliographyReportForGivenRatesSuccess = (
  bibliographyReportCSVJsonData,
) => ({
  type: type.GET_BIBLIOGRAPHY_REPORT_FOR_RATES_SUCCESS,
  bibliographyReportCSVJsonData,
});

export const getBibliographyReportForGivenRatesError = (errorMessage) => ({
  type: type.GET_BIBLIOGRAPHY_REPORT_FOR_RATES_ERROR,
  errorMessage,
});

export const getUserSubmittedQuestionsReportForGivenRates = (rates) => ({
  type: type.GET_USER_SUBMITTED_QUESTIONS_REPORT_FOR_RATES,
  rates,
});

export const callUsersCount = () => ({
  type: type.CALL_USERS_COUNT,
});

export const getUsersCount = (query) => ({
  type: type.GET_USERS_COUNT,
  query,
});

export const setGraphSagas = (graph) => ({
  type: type.SET_GRAPH,
  graph,
});

export const getUsersCountSuccess = (usersCountData) => ({
  type: type.GET_USERS_COUNT_SUCCESS,
  usersCountData,
});

export const getUsersCountError = (errorMessage) => ({
  type: type.GET_USERS_COUNT_ERROR,
  errorMessage,
});

export const setCompletionStatus = (data) => ({
  type: type.GET_COMPLETION_STATUS,
  data,
});

export const getAllMasterUserReport = () => ({
  type: type.GET_ALL_MASTER_USER_REPORT,
});

export const setAllMasterUserReportLoading = (value) => ({
  type: type.SET_ALL_MASTER_USER_REPORT_LOADING,
  value,
});

export const getAllActiveSubscriptionsReport = () => ({
  type: type.GET_ALL_ACTIVE_SUBSCRIPTIONS_REPORT,
});

export const setAllActiveSubscriptionsReportLoading = (value) => ({
  type: type.SET_ALL_ACTIVE_SUBSCRIPTIONS_REPORT_LOADING,
  value,
});

export const setAllMasterUserReport = (response) => ({
  type: type.SET_ALL_MASTER_USER_REPORT,
  response,
});

export const setAllActiveSubscriptionsReport = (response) => ({
  type: type.SET_ALL_ACTIVE_SUBSCRIPTIONS_REPORT,
  response,
});

export const clearAutomaticMasterReportProps = () => ({
  type: type.CLEAR_AUTOMATIC_MASTER_REPORT_PROPS,
});

export const clearAutomaticActiveSubscriptions = () => ({
  type: type.CLEAR_AUTOMATIC_ACTIVE_SUBSCRIPTIONS,
});

export const setAllMasterUserReportError = () => ({
  type: type.SET_ALL_MASTER_USER_REPORT_ERROR,
});

export const setUserSubmittedQuestionsReport = (response) => ({
  type: type.SET_USER_SUBMITTED_QUESTIONS_REPORT_FOR_RATES,
  response,
});

export const setIsUserSubmittedQuestionsReportLoading = (value) => ({
  type: type.SET_IS_USER_SUBMITTED_QUESTIONS_REPORT_FOR_RATES_LOADING,
  value,
});

export const setUserSubmittedQuestionsReportError = (error) => ({
  type: type.SET_USER_SUBMITTED_QUESTIONS_REPORT_FOR_RATES_ERROR,
  error,
});

export const getNumberOfQuestionsEnabledPerRatingExamReport = (lastRate) => ({
  type: type.GET_NUMBER_OF_QUESTIONS_ENABLED_PER_RATING_EXAM_REPORT,
  lastRate,
});

export const setNumberOfQuestionsEnabledPerRatingExamReport = (response) => ({
  type: type.SET_NUMBER_OF_QUESTIONS_ENABLED_PER_RATING_EXAM_REPORT,
  response,
});

export const clearNumberOfQuestionsEnabledPerRatingExamReportProps = () => ({
  type: type.CLEAR_NUMBER_OF_QUESTIONS_ENABLED_PER_RATING_EXAM_REPORT_PROPS,
});

export const setNumberOfQuestionsEnabledPerRatingExamReportError = () => ({
  type: type.SET_NUMBER_OF_QUESTIONS_ENABLED_PER_RATING_EXAM_REPORT_ERROR,
});

export const clearNumberOfQuestionsEnabledPerRatingExamAPIError = () => ({
  type: type.CLEAR_NUMBER_OF_QUESTIONS_ENABLED_PER_RATING_EXAM_API_ERROR,
});

/* Intercom Active Users Report */
export const generateIntercomActiveUsersReport = () => ({
  type: type.GENERATE_INTERCOM_ACTIVE_USERS_REPORT,
});
export const getLatestIntercomActiveUsersReport = () => ({
  type: type.GET_LATEST_INTERCOM_ACTIVE_USERS_REPORT,
});
export const setIntercomActiveUsersReport = (report) => ({
  type: type.SET_INTERCOM_ACTIVE_USERS_REPORT,
  payload: report,
});

/* Favorite questions report */
export const generateFavoriteQuestionsReport = (
  ratesIds,
  selectedRatingExams,
) => ({
  type: type.GENERATE_FAVORITE_QUESTIONS_REPORT_FOR_RATES,
  ratesIds,
  selectedRatingExams,
});
export const getLastFavoriteQuestionsReports = () => ({
  type: type.GET_LAST_FAVORITE_QUESTIONS_REPORTS,
});
export const setLastFavoriteQuestionsReport = (reports) => ({
  type: type.SET_LAST_FAVORITE_QUESTIONS_REPORTS,
  reports,
});
export const setIsLoadingFavoriteQuestionsReport = (ratesIds) => ({
  type: type.LOADING_FAVORITE_QUESTIONS_REPORT,
  ratesIds,
});

/* Rate questions report */
export const generateRateQuestionsReport = (ratesIds) => ({
  type: type.GENERATE_RATE_QUESTIONS_REPORT,
  ratesIds,
});
export const getLastRateQuestionsReports = () => ({
  type: type.GET_LAST_RATE_QUESTIONS_REPORTS,
});
export const setLastRateQuestionsReport = (reports) => ({
  type: type.SET_LAST_RATE_QUESTIONS_REPORTS,
  reports,
});
export const setIsLoadingRateQuestionsReport = (ratesIds) => ({
  type: type.LOADING_RATE_QUESTIONS_REPORT,
  ratesIds,
});

/* Usage report */
export const generateUsageReport = (
  fromDate,
  untilDate,
  fromDateComparison,
  untilDateComparison,
) => ({
  type: type.GENERATE_USAGE_REPORT,
  fromDate,
  untilDate,
  fromDateComparison,
  untilDateComparison,
});
export const updateUsageReports = (report) => ({
  type: type.UPDATE_USAGE_REPORTS,
  report,
});

export const getUsageReports = () => ({
  type: type.GET_USAGE_REPORTS,
});
export const setUsageReports = (reports) => ({
  type: type.SET_USAGE_REPORTS,
  reports,
});
export const setUsageReportsIsLoading = (value) => ({
  type: type.SET_USAGE_REPORTS_IS_LOADING,
  value,
});

/* Books missing answers report */
export const getLatestBooksMissingAnswersReport = () => ({
  type: type.GET_LATEST_BOOKS_MISSING_ANSWERS_REPORT,
});
export const generateBooksMissingAnswersReport = () => ({
  type: type.GENERATE_BOOKS_MISSING_ANSWERS_REPORT,
});
export const setBooksMissingAnswersReportData = (
  booksMissingAnswersReport,
) => ({
  type: type.SET_BOOKS_MISSING_ANSWERS_REPORT_DATA,
  payload: booksMissingAnswersReport,
});
export const setBooksMissingAnswersReportStateSuccess = () => ({
  type: type.SET_BOOKS_MISSING_ANSWERS_REPORT_STATE,
  payload: {
    state: BOOKS_MISSING_ANSWERS_REPORT_SUCCESS,
  },
});
export const setBooksMissingAnswersReportStateError = () => ({
  type: type.SET_BOOKS_MISSING_ANSWERS_REPORT_STATE,
  payload: {
    state: BOOKS_MISSING_ANSWERS_REPORT_ERROR,
  },
});
export const setBooksMissingAnswersReportStateLoading = () => ({
  type: type.SET_BOOKS_MISSING_ANSWERS_REPORT_STATE,
  payload: {
    state: BOOKS_MISSING_ANSWERS_REPORT_LOADING,
  },
});

// Audio report
export const getAudioReports = () => ({
  type: type.GET_AUDIO_REPORTS,
});
export const setAudioReports = (data) => ({
  type: type.SET_AUDIO_REPORTS,
  payload: data,
});
export const generateAudioReport = (rate) => ({
  type: type.GENERATE_AUDIO_REPORT,
  payload: rate,
});
export const setAudioReportStateLoading = (rate) => ({
  type: type.SET_AUDIO_REPORT_STATE,
  payload: {
    rate,
    state: audioReportState.AUDIO_REPORT_LOADING,
  },
});
export const setAudioReportStateError = (rate) => ({
  type: type.SET_AUDIO_REPORT_STATE,
  payload: {
    rate,
    state: audioReportState.AUDIO_REPORT_ERROR,
  },
});
export const setAudioReportStateSuccess = (rate) => ({
  type: type.SET_AUDIO_REPORT_STATE,
  payload: {
    rate,
    state: audioReportState.AUDIO_REPORT_SUCCESS,
  },
});
export const setAudioReportData = (data) => ({
  type: type.SET_AUDIO_REPORT_DATA,
  payload: data,
});

export const getLatestAudioAbbreviationsReport = () => ({
  type: type.GET_LATEST_AUDIO_ABBREVIATIONS_REPORT,
});
export const generateAudioAbbreviationsReport = () => ({
  type: type.GENERATE_AUDIO_ABBREVIATIONS_REPORT,
});
export const setAudioAbbreviationsReport = (report) => ({
  type: type.SET_AUDIO_ABBREVIATIONS_REPORT,
  payload: report,
});

/* Referred Leads Report */
export const getLatestReferredLeadsReport = () => ({
  type: type.GET_LATEST_REFERRED_LEADS_REPORT,
});

export const generateReferredLeadsReport = () => ({
  type: type.GENERATE_REFERRED_LEADS_REPORT,
});

export const setReferredLeadsReportData = (referredLeadsReport) => ({
  type: type.SET_REFERRED_LEADS_REPORT_DATA,
  payload: referredLeadsReport,
});

export const setReferredLeadsReportStateSuccess = () => ({
  type: type.SET_REFERRED_LEADS_REPORT_STATE,
  payload: {
    state: REFERRED_LEADS_REPORT_SUCCESS,
  },
});

export const setReferredLeadsReportStateError = () => ({
  type: type.SET_REFERRED_LEADS_REPORT_STATE,
  payload: {
    state: REFERRED_LEADS_REPORT_ERROR,
  },
});

export const setReferredLeadsReportStateLoading = () => ({
  type: type.SET_REFERRED_LEADS_REPORT_STATE,
  payload: {
    state: REFERRED_LEADS_REPORT_LOADING,
  },
});

/* Subscription Types Report */
export const generateSubscriptionTypesReport = (
  fromDate,
  untilDate,
  fromDateComparison,
  untilDateComparison,
) => ({
  type: type.GENERATE_SUBSCRIPTION_TYPES_REPORT,
  fromDate,
  untilDate,
  fromDateComparison,
  untilDateComparison,
});

export const updateSubscriptionTypesReports = (report) => ({
  type: type.UPDATE_SUBSCRIPTION_TYPES_REPORTS,
  report,
});

export const getSubscriptionTypesReports = () => ({
  type: type.GET_SUBSCRIPTION_TYPES_REPORTS,
});

export const setSubscriptionTypesReports = (reports) => ({
  type: type.SET_SUBSCRIPTION_TYPES_REPORTS,
  reports,
});

export const setSubscriptionTypesReportsIsLoading = (value) => ({
  type: type.SET_SUBSCRIPTION_TYPES_REPORTS_IS_LOADING,
  value,
});

/* Assigned to Writers Report */
export const getLatestAssignedToWritersReport = () => ({
  type: type.GET_LATEST_ASSIGNED_TO_WRITERS_REPORT,
});

export const generateAssignedToWritersReport = () => ({
  type: type.GENERATE_ASSIGNED_TO_WRITERS_REPORT,
});

export const setAssignedToWritersReportData = (assignedToWritersReport) => ({
  type: type.SET_ASSIGNED_TO_WRITERS_REPORT_DATA,
  payload: assignedToWritersReport,
});

export const setAssignedToWritersReportStateSuccess = () => ({
  type: type.SET_ASSIGNED_TO_WRITERS_REPORT_STATE,
  payload: {
    state: ASSIGNED_TO_WRITERS_REPORT_SUCCESS,
  },
});

export const setAssignedToWritersReportStateError = () => ({
  type: type.SET_ASSIGNED_TO_WRITERS_REPORT_STATE,
  payload: {
    state: ASSIGNED_TO_WRITERS_REPORT_ERROR,
  },
});

export const setAssignedToWritersReportStateLoading = () => ({
  type: type.SET_ASSIGNED_TO_WRITERS_REPORT_STATE,
  payload: {
    state: ASSIGNED_TO_WRITERS_REPORT_LOADING,
  },
});

/* Self Promotion Status Report */
export const getLatestSelfPromotionReport = () => ({
  type: type.GET_LATEST_SELF_PROMOTION_REPORT,
});

export const generateSelfPromotionReport = () => ({
  type: type.GENERATE_SELF_PROMOTION_REPORT,
});

export const setSelfPromotionReportData = (selfPromotionReport) => ({
  type: type.SET_SELF_PROMOTION_REPORT_DATA,
  payload: selfPromotionReport,
});

export const setSelfPromotionReportStateSuccess = () => ({
  type: type.SET_SELF_PROMOTION_REPORT_STATE,
  payload: { state: SELF_PROMOTION_REPORT_SUCCESS },
});

export const setSelfPromotionReportStateError = () => ({
  type: type.SET_SELF_PROMOTION_REPORT_STATE,
  payload: { state: SELF_PROMOTION_REPORT_ERROR },
});

export const setSelfPromotionReportStateLoading = () => ({
  type: type.SET_SELF_PROMOTION_REPORT_STATE,
  payload: { state: SELF_PROMOTION_REPORT_LOADING },
});
